import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "table-title-btns"
  }, [_vm.isAuth("home.setTemplateListList") ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.toConfigurationTemplate
    }
  }, [_vm._v(_vm._s(_vm.$t("配置模板")))]) : _vm._e()], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.editFileTemplate(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]), _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.fieldMaintenance(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("字段维护")))])];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.changeStatus(record);
            }
          }
        })];
      }
    }, {
      key: "anchorPointRender",
      fn: function (text, record) {
        return [_c("a-select", {
          ref: "select",
          staticStyle: {
            width: "120px"
          },
          on: {
            change: function ($event) {
              return _vm.handleChange(record);
            }
          },
          model: {
            value: record["anchorPoint"],
            callback: function ($$v) {
              _vm.$set(record, "anchorPoint", $$v);
            },
            expression: "record['anchorPoint']"
          }
        }, [_c("a-select-option", {
          attrs: {
            value: "POLICY_GENERATE"
          }
        }, [_vm._v(_vm._s(_vm.$t("生成批单")))]), _c("a-select-option", {
          attrs: {
            value: "POLICY_PREVIEW"
          }
        }, [_vm._v(_vm._s(_vm.$t("预览批单")))]), _c("a-select-option", {
          attrs: {
            value: "POLICY_GENERATE_SEND"
          }
        }, [_vm._v(_vm._s(_vm.$t("生成并发送")))])], 1)];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    staticClass: "marginR15",
    on: {
      click: function ($event) {
        return _vm.$emit("previous");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.$router.push({
          name: "releaseManage"
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1), _c("a-modal", {
    attrs: {
      visible: _vm.visible,
      title: _vm.$t("配置模板"),
      width: 600
    },
    on: {
      ok: _vm.newConfigurationTemplate,
      cancel: function ($event) {
        _vm.visible = false;
      }
    }
  }, [_c("a-form-model", {
    ref: "form",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 14
      },
      rules: _vm.ruleData
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("关联客户"),
      required: ""
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("关联客户"),
      disabled: "",
      allowClear: ""
    },
    model: {
      value: _vm.form.customerName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerName", $$v);
      },
      expression: "form.customerName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险产品"),
      required: ""
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("保险产品"),
      disabled: "",
      allowClear: ""
    },
    model: {
      value: _vm.form.productName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "productName", $$v);
      },
      expression: "form.productName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("应用名称"),
      required: ""
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("应用名称"),
      disabled: "",
      allowClear: ""
    },
    model: {
      value: _vm.form.applicationName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "applicationName", $$v);
      },
      expression: "form.applicationName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件模板"),
      prop: "fileTemplateId"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("文件模板"),
      allowClear: "",
      disabled: _vm.isEdit,
      mode: "multiple"
    },
    model: {
      value: _vm.form.fileTemplateId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "fileTemplateId", $$v);
      },
      expression: "form.fileTemplateId"
    }
  }, _vm._l(_vm.fileList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1)], 1)], 1)], 1), _c("a-modal", {
    attrs: {
      visible: _vm.fieldVisible,
      title: _vm.$t("字段维护"),
      width: 600,
      wrapClassName: "disable-modal-class",
      footer: null
    },
    on: {
      ok: _vm.newConfigurationTemplate,
      cancel: function ($event) {
        _vm.fieldVisible = false;
      }
    }
  }, [_c("div", {
    staticClass: "field-container"
  }, _vm._l(_vm.fieldMaintenanceData, function (item, index) {
    return _c("div", {
      key: item.index,
      staticClass: "field-item",
      class: index % 2 !== 0 ? "bg-class" : ""
    }, [_c("span", [_vm._v(_vm._s(item.index))]), _c("span", {
      staticClass: "title",
      attrs: {
        title: item.value
      }
    }, [_vm._v(_vm._s(item.value + ":"))]), _c("span", [_vm._v(_vm._s("${" + item.key + "}"))])]);
  }), 0)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };